// automatic written by ruby script .. please dont edit these comments!
// storyblok attributes:
//   embed_code -> textarea /
//   ratio -> option / Seitenverhältnis
// end of automatic

import React from "react"
import BlockWrapper from "../technical/BlockWrapper"

import KlaroConsentInfo from "../../../../../src/components/modules/KlaroConsentInfo"
import useKlaroConsentable from "../../../../../src/hooks/useKlaroConsentable"
import BlockHeader from "../../../../components/modules/BlockHeader"
import WidgetEmbed from "../technical/WidgetEmbed"

const EmbedBlock = ({ block }) => {
  const { usageConsented, appInfo, handleKlaroConsent } = useKlaroConsentable(
    block.user_consent
  )

  return (
    <BlockWrapper block={block}>
      <BlockHeader
        className="pb-2 md:pb-6"
        kicker={block.kicker}
        headline={block.headline}
        block={block.subheadline}
        text={block.text}
        links={block.link_items}
      />
      {typeof window !== "undefined" && window.storyblok?.inEditor && (
        <div
          className="py-2 mb-8 rounded px-grid"
          style={{ backgroundColor: "#09b3af" }}
        >
          <p className="font-medium prose text-ro-white">
            <h3 style={{ color: "#ffffff" }}>Hinweis:</h3>
            <b>Embed-Block:</b> Eingebettete Inhalte, welche Scripte verwenden,
            können unter Umständen in der <i>Vorschau</i> nicht korrekt
            angezeigt werden.
          </p>
        </div>
      )}
      {block.user_consent ? (
        <>
          {usageConsented !== null && (
            <div className={`${block.headline?.length > 0 ? "pt-8" : ""}`}>
              {usageConsented !== null &&
                (usageConsented === false && appInfo !== null ? (
                  <div className={`embed embed-${block.ratio}`}>
                    <KlaroConsentInfo
                      appInfo={appInfo}
                      handleKlaroConsent={handleKlaroConsent}
                      renderWrapper={false}
                      textPositionClassName="text-left"
                    />
                  </div>
                ) : (
                  <>
                    <div
                      className={`embed embed-${
                        block.ratio ? block.ratio : "16by9"
                      }`}
                    >
                      <WidgetEmbed widgetHtml={block.embed_code} />
                    </div>
                  </>
                ))}
            </div>
          )}
        </>
      ) : (
        <div className={`embed embed-${block.ratio ? block.ratio : "16by9"}`}>
          <WidgetEmbed widgetHtml={block.embed_code} />
        </div>
      )}
    </BlockWrapper>
  )
}

export default EmbedBlock
